<template>
  <b-card
    class="video-details-user-interactions"
    no-body
  >
    <b-card no-body>
      <b-card-header class="border-bottom">
        <b-card-title class="font-weight-bold text-secondary font-medium-3">
          <span>{{ $t('User Interactions') }}</span>
        </b-card-title>
      </b-card-header>
      <div>
        <b-row class="match-height">
          <b-col
            xl="4"
            md="6"
            sm="12"
            class="border-right"
          >
            <span class="text-center mt-1 font-medium-2 font-weight-bold text-dark">
              {{ $t('Views') }}
            </span>
            <statistic-card-vertical
              color="primary"
              icon="EyeIcon"
              :statistic="uiData.pvCount? uiData.pvCount.toLocaleString() : 0"
              statistic-title=""
            />
          </b-col>
          <b-col
            xl="4"
            md="6"
            sm="12"
            class="border-right"
          >
            <span class="text-center mt-1 font-medium-2 font-weight-bold text-dark">
              {{ $t('Launched') }}
            </span>
            <statistic-card-vertical
              color="warning"
              icon="PlayIcon"
              :statistic="uiData.videoPlayCount? uiData.videoPlayCount.toLocaleString() : 0"
              statistic-title=""
            />
          </b-col>
          <b-col
            xl="4"
            md="3"
            sm="12"
          >
            <span class="text-center mt-1 font-medium-2 font-weight-bold text-dark">
              {{ $t('Completed') }}
            </span>
            <statistic-card-vertical
              color="info"
              icon="AwardIcon"
              class="font-medium-1 font-weight-bold text-dark"
              :statistic="uiData.videoCompleted? uiData.videoCompleted.toLocaleString() : 0"
              statistic-title=""
            />
          </b-col>
        </b-row>
      </div>
    </b-card>
  </b-card>
</template>

<script>
import {
    BRow, BCol, BCard, BCardTitle, BCardHeader, VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import StatisticCardVertical from '@core/components/statistics-cards/StatisticCardVertical.vue'

export default {
    components: {
        StatisticCardVertical,
        BRow,
        BCol,
        BCard,
        BCardTitle,
        BCardHeader,
    },
    directives: {
        Ripple,
        'b-tooltip': VBTooltip,
    },
    props: {
        uiData: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {}
    },
}
</script>
